import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Clock } from "lucide-react";

export const ArticleCard = ({ article, index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.45, delay: Math.min(index * 0.06, 0.4), ease: "easeOut" }}
    >
      <Link
        to={`/dossier/${article.slug}`}
        data-testid={`article-card-${article.slug}`}
        className="group block h-full border border-white/10 bg-card hover:border-gold/40 transition-colors duration-300"
      >
        <div className="relative aspect-[16/10] overflow-hidden">
          <img
            src={article.image_url}
            alt={article.title}
            loading="lazy"
            className="w-full h-full object-cover grayscale-[35%] group-hover:grayscale-0 group-hover:scale-[1.04] transition-all duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-card via-card/30 to-transparent" />
          <span className="absolute top-3 left-3 overline text-gold bg-black/70 px-2 py-1 border border-gold/30">
            {article.category}
          </span>
        </div>
        <div className="p-5">
          <h3 className="font-display text-xl text-white leading-snug tracking-tight group-hover:text-gold transition-colors">
            {article.title}
          </h3>
          <p className="mt-2.5 text-sm text-white/55 leading-relaxed line-clamp-2">{article.excerpt}</p>
          <div className="mt-4 flex items-center justify-between">
            <span className="overline text-white/35 inline-flex items-center gap-1.5">
              <Clock className="w-3 h-3" /> {article.read_time_min} min read
            </span>
            <ArrowUpRight className="w-4 h-4 text-gold opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all" />
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
